import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { FaHome, FaUsers, FaEnvelope, FaBullhorn, FaChartBar } from 'react-icons/fa';
import ParentDashboard from './Dashboard';
import ChildProgress   from './ChildProgress';
import Messages        from './Messages';
import ParentNotices   from './Notices';
import ParentAnalytics from './Analytics';

const navItems = [
  { type: 'section', label: 'Overview' },
  { to: '/parent',           label: 'Dashboard',           icon: FaHome },
  { type: 'section', label: 'My Children' },
  { to: '/parent/progress',  label: "Children's Progress", icon: FaUsers },
  { to: '/parent/analytics', label: 'Performance Analytics', icon: FaChartBar },
  { type: 'section', label: 'Communication' },
  { to: '/parent/notices',   label: 'Notices',             icon: FaBullhorn },
  { to: '/parent/messages',  label: 'Messages',            icon: FaEnvelope },
];

export default function ParentApp() {
  return (
    <DashboardLayout sidebarItems={navItems}>
      <Routes>
        <Route index             element={<ParentDashboard />} />
        <Route path="progress"   element={<ChildProgress />} />
        <Route path="analytics"  element={<ParentAnalytics />} />
        <Route path="notices"    element={<ParentNotices />} />
        <Route path="messages"   element={<Messages />} />
        <Route path="*"          element={<Navigate to="/parent" replace />} />
      </Routes>
    </DashboardLayout>
  );
}
